export default "__VITE_ASSET__DHoeBdIi__"